import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { options: Object }

  connect() {
    window.Inputmask = import("inputmask/dist/inputmask.es6.js")
  }

  initialize() {
    window.Inputmask(this.optionsValue).mask(this.element)
  }
}
